var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Skyflow from 'skyflow-js';
import useCollectListeners from '../../hooks/CollectListner';
const InputFieldElement = (_a) => {
    var props = __rest(_a, []);
    const divElement = document.createElement('div');
    if (props.id) {
        divElement.setAttribute('id', props.id);
    }
    else {
        divElement.setAttribute('id', 'collectInputElement');
    }
    React.useEffect(() => {
        try {
            const newElement = props.container.create(Object.assign(Object.assign({ table: props.table, column: props.column }, props.classes), { placeholder: props.placeholder || '', label: props.label || '', type: Skyflow.ElementType.INPUT_FIELD, validations: props.validations || [] }), Object.assign({}, props.options));
            newElement.mount(props.id ? `#${props.id}` : '#collectInputElement');
            useCollectListeners(props, newElement);
        }
        catch (e) {
            console.log(e);
        }
    }, []);
    return React.createElement("div", { id: props.id ? props.id : 'collectInputElement' });
};
export default InputFieldElement;
//# sourceMappingURL=index.js.map